/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Action_HeaderInputs */



/**
* | output |
* | --- |
* | "Action" |
*
* @param {Options_Pedal_Action_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_action_header = /** @type {((inputs?: Options_Pedal_Action_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Action_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Action")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktion")
	if (locale === "it") return /** @type {LocalizedString} */ ("Azione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Действие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Acción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("行动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アクション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्रवाई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ação")
	return /** @type {LocalizedString} */ ("Action")
});